import { useCallback } from 'react'
import { setDateValue } from '../../functions'

export function useDate() {
  const assignAndFormatDates = useCallback((record: any) => {
    const newRecord = { ...record }

    const { nextActionDate, expectedClosingDate } = newRecord.row

    ;[nextActionDate, expectedClosingDate].forEach((dateField) => {
      if (dateField?.value) {
        dateField.value = setDateValue(dateField.value)
      }
    })

    return newRecord
  }, [])

  return {
    assignAndFormatDates,
  }
}
